<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">

   

    <div class="imagen-xv-shell" ref="fotoShell">
      <div class="imagen-xv-wrapper">
        <img
          src="@/assets/4.webp"
          class="imagen-xv"
          alt="Foto protagonista"
        />
      </div>

      <div class="mono-portada">
        <img
          :src="require('@/assets/moñi.png')"
          class="mono-portada-img"
          alt="Moño decorativo"
        />
      </div>
    </div>


  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)
    const fotoShell = ref(null)

    onMounted(async () => {
      await nextTick()

      const foto = fotoShell.value
      const flores = gsap.utils.toArray('.flor')
      const bola = document.querySelector('.bola')

      // 1. Estado inicial: Ocultamos y bajamos un poco la posición
      gsap.set([foto, ...flores, bola], { 
        autoAlpha: 0, 
        y: 40 
      })

      // 2. Observer: Se activa apenas entra un 10% del elemento (ideal para móvil)
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power4.out' } })

          // ANIMACIÓN ELEGANTE DE LA FOTO
          tl.to(foto, {
            autoAlpha: 1,
            y: 0,
            duration: 1.5,
            // Efecto de zoom y enfoque
            startAt: { scale: 0.85, filter: 'blur(15px)' },
            scale: 1,
            filter: 'blur(0px)',
          })

          // ENTRADA DE LAS FLORES (Efecto abanico)
          tl.to(flores, {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            stagger: 0.2,
            ease: "back.out(1.2)"
          }, "-=1") // Empieza un poco antes de que termine la foto

          // ENTRADA DE LA BOLA DISCO
          tl.to(bola, {
            autoAlpha: 0.85,
            y: 0,
            duration: 1.2
          }, "-=0.8")

          io.disconnect() // Para que no se repita
        })
      }, { threshold: 0.1 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef, fotoShell }
  }
}
</script>

<style scoped>
/* PADRINOS */
.padrinos{
  margin-top: 18px;
}
.padrinos-titulo{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color:#6a6a6a;
  margin: 10px 0 2px;
}
.padrinos-nombres{
  font-family: "titulos", cursive;
  font-size: 35px;
  color:#043b73;
  margin: 0 0 8px;
}
</style>


<style scoped>
.portada-xv{
  position:relative;
  width:100%;
  min-height:45vh;
  background:#f3f7fd;
  overflow:visible;
  display:flex;
  margin-top:-50px;
  flex-direction:column;
  align-items:center;
  margin-bottom: -50px;
  justify-content:flex-start;
  padding:0px 16px 0px;
}

/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 76px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
  position: relative; /* para posicionar el moño dentro */
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* 🎀 Moño en la parte superior derecha de la foto */
.mono-portada{
  position:absolute;
  top:22px;
  right: -25px;
  z-index: 9995;
  transform: rotate(22deg);

}
.mono-portada-img{
  width: 240px;
  height: auto;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: -22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 52px;
  color: #043b73;
  margin: 0 0 8px 0;
  line-height: 1.1;
}

.nombre-protagonista2{
  font-family: "titulos", cursive;
  font-size: 82px;
  
  color:#043b73;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:80px; left:-60px; z-index:5; }
.flor-2{ top:205px; right:-80px; transform: rotate(-80deg); z-index:0; width:min(60vw, 340px); }
.flor-3{ bottom:-50px; left:-100px; transform: rotate(-30deg); z-index:9;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:210px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  will-change: transform;
}
.bola-izquierda{ left:207px; bottom:-128px; z-index:9;}
@keyframes girar {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}
</style>
